import { render, staticRenderFns } from "./IconArrowLeftSolid.vue?vue&type=template&id=c36b37dc"
import script from "./IconArrowLeftSolid.vue?vue&type=script&lang=js"
export * from "./IconArrowLeftSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports